import { render, staticRenderFns } from "./ArticleCadPreview.vue?vue&type=template&id=0b782e9f"
import script from "./ArticleCadPreview.vue?vue&type=script&lang=ts"
export * from "./ArticleCadPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports